
import { defineComponent, PropType } from 'vue'

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { DocumentDownloadIcon } from '@heroicons/vue/outline'
import { useUserStore } from '@/stores/userStore'
import { PaperID, ReferenceManagers } from '@/types/incitefulTypes'
import api from '@/utils/incitefulApi'
import router from '../router/index';

export default defineComponent({
  name: 'SaveDropDown',
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    DocumentDownloadIcon
  },
  props: {
    ids: {} as PropType<PaperID[]>
  },
  setup(props) {
    let user = useUserStore()

    const saveToFavorites = () => {
      if (props.ids !== undefined) {
        user.addFavorites(props.ids)
      }
    }
    const downloadBibFile = () => {
      if (props.ids !== undefined) api.downloadBibFile(props.ids)
    }
    const downloadRisFile = () => {
      if (props.ids !== undefined) api.downloadRisFile(props.ids)
    }

    const exportIds = (tool: ReferenceManagers) => {
      let ids = props.ids
      const routeData = router.resolve({ name: 'ToolExport', query: { ids, tool } })
      window.open(routeData.href, '_blank');
    }

    const exportToZotero = () => {
      exportIds(ReferenceManagers.Zotero)
    }

    const exportToMendeley = () => {
      exportIds(ReferenceManagers.Mendeley)
    }

    return {
      user,
      downloadBibFile,
      downloadRisFile,
      saveToFavorites,
      exportToMendeley,
      exportToZotero
    }
  }
})
